module.exports = __webpack_public_path__ + "static/media/info-circle.8866068a.svg";